import { useState, useCallback } from 'react';
import { getDateRange } from '../utils/dateUtils';
import { DATE_RANGES } from '../../core/constants';

export const useFiltros = (storageKey = 'filtrosTurnos') => {
  const { desde, hasta } = getDateRange(
    DATE_RANGES.INITIAL_DAYS_BACK,
    DATE_RANGES.FINAL_DAYS_FORWARD
  );

  const [filtros, setFiltros] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved) {
        return JSON.parse(saved);
      }
    } catch (error) {
      console.error('Error al recuperar filtros:', error);
    }
    return {
      fechaDesde: desde,
      fechaHasta: hasta,
      centro: '',
      tipoEstudio: '',
      procesador: '',
      nombre: '',
      idHorario: '',
      estadoTurno: '',
      categoria: '',
      obraSocial: '',
      equipo: '',
      equipoCPAP: '',
      canales: '',
      mostrarEnviados: false,
    };
  });

  const handleFiltroChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    setFiltros(prev => {
      const newFiltros = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      };
      localStorage.setItem(storageKey, JSON.stringify(newFiltros));
      return newFiltros;
    });
  }, [storageKey]);

  const limpiarFiltros = useCallback(() => {
    const { desde, hasta } = getDateRange(
      DATE_RANGES.INITIAL_DAYS_BACK,
      DATE_RANGES.FINAL_DAYS_FORWARD
    );
    const filtrosLimpios = {
      fechaDesde: desde,
      fechaHasta: hasta,
      centro: '',
      tipoEstudio: '',
      procesador: '',
      nombre: '',
      idHorario: '',
      estadoTurno: '',
      categoria: '',
      obraSocial: '',
      equipo: '',
      equipoCPAP: '',
      canales: '',
      mostrarEnviados: false,
    };
    localStorage.setItem(storageKey, JSON.stringify(filtrosLimpios));
    setFiltros(filtrosLimpios);
  }, [storageKey]);

  return {
    filtros,
    handleFiltroChange,
    limpiarFiltros,
  };
};
